import axios from "axios";
import { authenticatedApiConfig, generateURL } from "./BaseApiService";
export class GlobalAdminRetrievalService {
    constructor(authenticationProvider, environment) {
        this.authenticationProvider = authenticationProvider;
        this.environment = environment;
    }
    async getPatientVectorizationStatus(patientId) {
        const response = await axios.get(generateURL(this.environment.API_BASE_URL, "/admin/patients/:patientId/details", { patientId }), await authenticatedApiConfig(this.authenticationProvider));
        return response.data;
    }
    async migratePatient(patientId) {
        const response = await axios.post(generateURL(this.environment.API_BASE_URL, "/admin/patients/:patientId/migrate", { patientId }), {}, await authenticatedApiConfig(this.authenticationProvider));
        return response.data;
    }
    async getMigrationSummary() {
        const response = await axios.get(generateURL(this.environment.API_BASE_URL, "/admin/migration/summary"), await authenticatedApiConfig(this.authenticationProvider));
        return response.data;
    }
    async searchPatients(query) {
        const params = new URLSearchParams();
        if (query.firstName)
            params.append("firstName", query.firstName);
        if (query.lastName)
            params.append("lastName", query.lastName);
        if (query.email)
            params.append("email", query.email);
        const response = await axios.get(`${this.environment.API_BASE_URL}/admin/patients/search?${params.toString()}`, await authenticatedApiConfig(this.authenticationProvider));
        return response.data;
    }
}
